import * as React from "react";

import { Container, Typography, Pagination } from "@mui/material";
import CaseCard from "../../Modules/ViewCase/CaseCard";
import { CaseCardType } from "../../Modules/ViewCase/CaseCard";
import { useSearchParams } from "react-router-dom";
import { useWindowDimensions } from "../../Functions/ScreenOperation/useWindowDimension";
//import './catalogueStyles/catalogueSearchTable.css';
import { Grid } from "@mui/material";

type CatalogueMenuType = {
  cases: CaseCardType[];
};

export default function CatalogueMenu(props: CatalogueMenuType) {
  const cases = props.cases;

  const { width } = useWindowDimensions();

  const [page, setPage] = React.useState(0);
  const rowsPerPage = 12;

  const handleUpPage = (event: unknown, newPage: number) => {
    setPage(page + 1);
  };

  const handleDownPage = (event: unknown, newPage: number) => {
    setPage(Math.max(page - 1, 0));
  };

  const [currentPage, setCurrentPage] = React.useState(1);
  const casesPerPage = 10;
  const indexOfLastCase = currentPage * casesPerPage;
  const indexOfFirstCase = indexOfLastCase - casesPerPage;
  const reversedCases = [...cases].reverse();
  const currentCases = reversedCases.slice(indexOfFirstCase, indexOfLastCase);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
    window.scrollTo({
      top: 0, // ページの最上部に移動
      behavior: 'smooth', // スクロールをスムーズにする
    });
  };

  /*
    React.useEffect(()=>{
        getDatabaseData('dwh','destInstitutionCode','==',"df0090fb-934e-11ee-96c4-f938a98198c2")
        .then((rowDatas)=>{
          const baseDatas:CaseCardType[] = rowDatas.map((data)=>{
            const content = data.value
            //const date = new Date(content.createTime.seconds * 1000 + content.createTime.nanoseconds / 1000)
            return {
                id:content.id, 
                title:content.title, 
                age:content.ageSearch, 
                sex:content.sex,
                patientId: content.patientId,
                site: content.site,
                modality: content.modality,
                date: content.uploadDate
            }
          })
          setCases(baseDatas)});
      },[]);
    */

  return (
    <div>
      {/*<div className='navigation'>
            <Tooltip title="検索に戻る">
                <Button>
                    <ArrowCircleLeftIcon
                        sx={{ fontSize: 60 }} color='primary'
                        onClick={() => { props.getContentsData('main', 'menuTable') }}></ArrowCircleLeftIcon>
                </Button>
            </Tooltip>
        </div>
        */}
      {cases.length === 0 ? (
        <Typography>No Rows to show</Typography>
      ) : (
        <Container
        sx={{maxWidth: width > 1500 ? "100%" : width > 800 ? "95%" : "100%",}}>
          <Grid
            item
            sx={{
              display: "Grid",
              alignItems: "center",
              justifyContent: "center",
              gridTemplateColumns: { sm: "50% 50%", xs: "100%" },
              spacing: { xs: 2, md: 3 },
              width: "100%",
              maxWidth:"100%",
              gap: { xs: 2, md: 4 },
              py: 8,
              mb: 2,
            }}
          >
            {currentCases.map((CaseData: CaseCardType) => (
              <CaseCard
                id={CaseData.id}
                key={CaseData.id}
                title={CaseData.title}
                age={CaseData.age}
                sex={CaseData.sex}
                patientId={CaseData.patientId}
                site={CaseData.site}
                modality={CaseData.modality}
                date={CaseData.date}
                organTags={CaseData.organTags}
                keyImages={CaseData.keyImages}
                casenumber={CaseData.casenumber}
                publishDate={CaseData.publishDate}
              />
            ))}
          </Grid>
          <Pagination
            count={Math.ceil(cases.length / casesPerPage)} // 総ページ数
            page={currentPage} // 現在のページ
            onChange={handlePageChange} // ページが変更された時のイベント
            color="primary" // ページネーションのスタイル
            sx={{ display: "flex", justifyContent: "center", mb: 5 }}
          />
        </Container>
      )}
    </div>
  );
}
